import { render, staticRenderFns } from "./HistoryResults.vue?vue&type=template&id=55e846a2&scoped=true"
import script from "./HistoryResults.vue?vue&type=script&lang=ts"
export * from "./HistoryResults.vue?vue&type=script&lang=ts"
import style0 from "./HistoryResults.vue?vue&type=style&index=0&id=55e846a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e846a2",
  null
  
)

export default component.exports